<template>
  <div class="single__gheom step__grid"
    :class="getMyTypeClass(this.my_selected_product.type)">
    <div class="step__head">
      <div class="info__block">
        <p v-if="isGheomEmpty" class="title">No gheom selected</p>
        <div v-else class="info__meta">
          <p class="subtitle">{{my_selected_product.name}}</p>
          <p class="title">{{my_selected_gheom.name}}</p>
          <p class="status" v-if="isFinished">
            Finished Gheom
          </p>
          <p class="status" v-else>
            Ongoing Gheom | {{my_selected_gheom.num_stages - my_selected_gheom.num_stages_finished}} Times to go
          </p>
        </div>
      </div>
      <div class="actions__block">
        <div class="actions__chart">
          <div class="chart__cont">
            <circle-chart
              :currentvalue="this.my_selected_gheom.num_stages_finished"
              :totalvalue="this.my_selected_gheom.num_stages"
              :dim="50">
            </circle-chart>
            <p class="value">{{my_selected_gheom.num_stages_finished}} / {{my_selected_gheom.num_stages}}</p>
          </div>
        </div>
        <div class="actions__grid">
          <ul>
            <li>
              <a href="">
                <i class='icon-anita-download'></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="step__body">
      <div v-if="isGheomEmpty">
        <p>No Gheom Selected</p>
      </div>
      <div v-else>
        <div v-if="loading" class="loading__cont">
          <gheom-loader
          :dim=200
          :mode=4>
          </gheom-loader>
        </div>
        <div v-else>
          <ul>
            <li
              v-for="(stage, index) in the_stages" :key="stage.id">
                <div class="timestamp"
                  :class="isCurrentStage(stage)">
                  <div class="timestamp__numbers">
                    <p class="mynumber">T{{stage.time}}</p>
                    <p class="internumber">{{getMyInterval(index)}}</p>
                  </div>
                  <div class="timeaxis">
                    <span></span>
                  </div>
                  <div class="inside__time">
                    <p class="gdate">{{ stage.controlgroup.date | gheomizeDateFirst}}<span>{{ stage.controlgroup.date | gheomizeDateSecond}}</span></p>
                    <div class="inside__time__content">
                      <div v-if="stage.controlgroup" class="st st__a">
                        <p class="st__title">Control <span>x{{stage.controlgroup.samples.length}}</span></p>
                        <ul class="replicas__grid">
                          <li
                          v-for="(sample, myindex) in stage.controlgroup.samples" :key="sample.c_muestra_wineseq">
                            <a href="#">
                              <reportfootprint
                                :theSample="sample"
                                :type=0
                              >
                              </reportfootprint>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div v-if="stage.treatedgroup" class="st st__b">
                        <p class="st__title">Treated <span>x{{stage.treatedgroup.samples.length}}</span></p>
                        <ul class="replicas__grid">
                          <li v-for="(sample, myoindex) in stage.treatedgroup.samples" :key="sample.c_muestra_wineseq">
                            <a href="#">
                              <reportfootprint
                                :theSample="sample"
                                :type=0
                              >
                              </reportfootprint>   
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
            </li>
          </ul>
        </div>

        <ul class="hide">
          <li v-for="(stage, index) in the_stages" :key="stage.id">
            <p>Stage {{index+1}} || Time {{stage.time}} || {{stage.finished}}</p>
            <p>Control </p>
              <div v-if="stage.controlgroup">
                {{stage.controlgroup.name}} || {{stage.controlgroup.num_replicas}}
                <ul>
                  <li v-for="(sample, myindex) in stage.controlgroup.samples" :key="sample.c_muestra_wineseq">
                    <a href="#">({{myindex+1}}) {{sample.c_muestra_wineseq}}</a>
                  </li>
                </ul>
              </div>

            <p>Treated</p>
              <div v-if="stage.treatedgroup">
                {{stage.treatedgroup.name}} || {{stage.treatedgroup.num_replicas}}
                <ul>
                  <li v-for="(sample, myoindex) in stage.treatedgroup.samples" :key="sample.c_muestra_wineseq">
                    <a href="#">({{myoindex+1}}) {{sample.c_muestra_wineseq}}</a>
                  </li>
                </ul>
              </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import reportfootprint from './ReportFootprint'
import Shared from '../Shared'

export default {
  extends: Shared,
  name: "",
  components: {
    reportfootprint
  },
  props: [
    "my_selected_gheom", "the_stages", "my_selected_product", "loading"
  ],
  computed: {
    isGheomEmpty: function() {
      return jQuery.isEmptyObject(this.my_selected_gheom)
    },
    isFinished: function(){
      if (this.my_selected_gheom.num_stages == this.my_selected_gheom.num_stages_finished) {
        return true
      }
    }
  },
  data:function(){ 
    return {
      
    }
  },
  methods: {
    getMyInterval(theIndex) {
      if(theIndex < this.the_stages.length - 1) {
        var a = moment(this.the_stages[theIndex].controlgroup.date);
        var b = moment(this.the_stages[theIndex+1].controlgroup.date)
        if(b.diff(a, 'months') < 1) {
          return "+"+b.diff(a, 'days')+"  days"
        } else if (b.diff(a, 'months') > 24) {
          return "+"+b.diff(a, 'years')+"  years"
        } else {
          return "+"+b.diff(a, 'months')+"  months"
        }
      }
    },
    isCurrentStage(stage) {
      
    } 
  }
}
</script>

